import { LicenseInfo } from '@mui/x-data-grid-pro';

LicenseInfo.setLicenseKey(
    'f8ac762d915bb499445fe3c75aea5f97T1JERVI6Mzk2NDMsRVhQSVJZPTE2Nzg4ODI2NjMwMDAsS0VZVkVSU0lPTj0x'
);